import { Dialog, DialogContent, DialogContentText, CircularProgress, Box } from '@mui/material';
import React, { useEffect } from 'react';
import { decodeState } from '../../utils/utilityFunctions';
import { useDispatch } from 'react-redux';
import {
  getDigilockerCallbackData,
  getInvestorTokenFromLanding,
} from '../redux/actions/digilocker';

const REDIRECTION_URL = 'https://aifdouat6.kfintech.com';

const query = new URLSearchParams(window.location.search);
const code = query.get('code');
const state = query.get('state');

export type DecodedState = {
  /**applicationId: string; referenceId: string; token: string; role: string */
  applicationId: string;
  token: string;
  digiLockerAMCCode: string;
  referenceId: string;
  digilockerId: string;
};

export const DigiLockerLoader = (): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      if (!code || !state) return;

      try {
        const decoded = decodeState<DecodedState>(state);
        if (!decoded?.token) return;

        dispatch(getInvestorTokenFromLanding({ token: decoded.token }));
        const response = (await dispatch(getDigilockerCallbackData(code, state))) as unknown as any;

        // const referenceId = response?.referenceId; // adjust field name once confirmed
        // if (!referenceId) return;
        // console.log(decoded);

        if (!decoded?.applicationId) return;

        const url = `${window.location.origin}/investment-details/${decoded?.referenceId}/application-details?code=${code}&state=${state}`;
        window.open(url, '_self');
      } catch (error) {
        console.error((error as Error).message);
      }
    })();
  }, []);

  return (
    <Dialog open sx={{ '& .MuiPaper-root': { padding: '30px', textAlign: 'center' } }}>
      <DialogContent>
        <DialogContentText>Data is fetching, Please wait</DialogContentText>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CircularProgress />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
